import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  smallLoadingSpinner: {
    marginTop: pxToRem(35),
  },
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  saveDraftButton: {
    marginRight: pxToRem(16),
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
  messageBar: {
    marginBottom: pxToRem(20),
    color: theme.palette.neutralDark,
    selectors: {
      '.ms-MessageBar-icon i': {
        color: theme.palette.neutralDark,
      },
    },
  },
  transparentBackground: {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  negativeAmount: {
    color: theme.palette.accentError,
  },
  dimText: {
    opacity: 0.5,
  },
  hidden: {
    visibility: 'hidden',
  },
  submitButton: {
    marginLeft: pxToRem(20),
  },
  discardReversalLoadingSpinner: {
    marginLeft: pxToRem(20),
  },
  textColorError: {
    color: theme.palette.accentError,
  },
  primaryBottomBorder: {
    borderBottom: `1px solid ${theme.palette.themePrimary}`,
  },
  headerRow: {
    backgroundColor: theme.palette.neutralWhite,
    borderBottom: `1px solid ${theme.palette.themePrimary}`,
    paddingTop: 0,
    paddingBottom: pxToRem(11),
    fontSize: pxToRem(14),
    fontWeight: 600,
    color: theme.palette.neutralDark,
  },
  column1: {
    minWidth: '20%',
    maxWidth: '20%',
    color: `${theme.palette.neutralDark} !important`,
  },
  column2: {
    textAlign: 'right',
    minWidth: '40%',
    maxWidth: '40%',
    color: `${theme.palette.neutralDark} !important`,
  },
  column3: {
    textAlign: 'right',
    minWidth: '40%',
    maxWidth: '40%',
    color: `${theme.palette.neutralDark} !important`,
  },
  columnHeaderText: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  advanceLogSection: {
    paddingBottom: pxToRem(60),
  },
});
